import React, { useEffect } from 'react';
import { AutoCompleteSelect } from '../../../autocomplete/select/auto-complete-select';
import { useComposicao } from '../../useProduto';
import { faSync } from '@fortawesome/pro-duotone-svg-icons'

const ProdutoSimplesSelector = (props)=> {


    const {autoCompleteProps, searchProps, inputProps, onSelect, getApi, innerRef} = props;

    const {onSearch, onFilter, dataStore} = useComposicao(getApi);

    const onSelectHandle = (value) => {
        
        const produtoSelecionado = dataStore.filter(produto => produto.descricao == value);

        if(produtoSelecionado.length == 1){
            onSelect && onSelect(produtoSelecionado[0]);
        } else {
            onSelect && onSelect(null);
        }
    }

    useEffect(()=>{
        onSearch();
    }, [true])
    
    return <AutoCompleteSelect
                autoCompleteProps={autoCompleteProps}
                searchProps={searchProps}
                searchInterface={{dataStore, onSearch, onFilter}}
                onSelect={onSelectHandle}
                inputProps={inputProps}
                icon={faSync}
                innerRef={innerRef}
            ></AutoCompleteSelect>

}

export {ProdutoSimplesSelector}